<script>
    import DocumentationField from '$lib/components/forms/DocumentationField.svelte'
    import { Typography } from '$lib/components/UI'
    import { confImp } from '$lib/conf'
    export let value = []
    export let providerData = {}
    export let taxConf = {}
    export let docs = []
    export let valid = true

    let values = {}
    let validations = {}

    // let laf = {
    //     'Constancia ARCA': '1',
    //     'Constancia Ingresos Brutos': '2',
    //     'Certificado de Retencion': '3',
    //     'Certificado de Exencion': '4',
    //     'Otros': '5',
    // }
    let tt = [
        // 'tipo_documentacion',
        'fecha_emision',
        'fecha_vencimiento',
        'jurisdiccion',
        'files',
        'observacion',
    ]

    let ref = {
        condicion_imp_iva_ii: 'condicion_iva',
        condicion_imp_ganancias_ii: 'condicion_ganancias',
        condicion_imp_ingresos_ii: 'condicion_iibb',
    }

    let changedCond = Object.entries(providerData) // Metadatos de condicion impositiva  actualizados
        .filter(([k, v]) => k in taxConf && taxConf[k] != v)
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})

    let updateDocs = Object.entries(changedCond) // Configuraciones sugeridas por actualizacion de condiciones de impuestos
        .map(([k, v]) => confImp[ref[k]][v])
        .filter((x) => x)

    let replaceDocs = docs.map(({ title, ...d }) => ({
        //Reconstruir configuracion de documentacion solicitada
        title,
        label: title,
        impuesto: d.impuesto,
        type: d.tipo_documentacion,
        optional: false,
        deleteable: false,
        insteadOf: d.id,
        inputs: Object.keys(d)
            .filter(
                (f) => tt.includes(f) && ![null, undefined, ''].includes(d[f])
            )
            .concat(['files'])
            .map((x) => `${x}*`)
            .concat(['observacion']),
    }))

    let allDocs = [...replaceDocs, ...updateDocs] // Clasificar por impuesto
        .reduce(
            (ac, c) => ({
                ...ac,
                ...(c.impuesto !== ''
                    ? {
                          [c.impuesto]:
                              'impuesto' in ac ? [...ac[c.impuesto], c] : [c],
                      }
                    : {
                          General: [...ac.General, c],
                      }),
            }),
            { General: [] }
        )

    // @ts-ignore
    $: value = Object.values(values).reduce(
        (ac, c) => (c instanceof Array ? ac.concat(c) : ac.concat([c])),
        []
    )
    $: valid =
        Object.values(validations).length > 0
            ? Object.values(validations).every((x) => x === true)
            : true
    $: console.log({ changedCond })
    $: available = Object.values(allDocs).reduce((r, c) => r + c.length, 0) > 0
</script>

<div>
    {#if available}
        {#each Object.entries(allDocs) as [category, configs] (category)}
            {#if configs.length > 0}
                <Typography type="h4" style="margin: 0 0 10px 0"
                    >Documentación {category}</Typography
                >
                {#each configs as conf, i (i)}
                    <DocumentationField
                        bind:valid={validations[conf.label]}
                        bind:value={values[`${category}${i}`]}
                        on:delete={() => {
                            values = Object.fromEntries(
                                Object.entries(values).filter(([k]) => k != `${category}${i}`)
                            )
                        }}
                        {...conf}
                    />
                {/each}
            {/if}
        {/each}
    {:else}
        <Typography
            type="h4"
            color="grey-400"
            style="user-select: none;margin: 150px auto; text-align: center"
            >No se requiere cargar nueva documentación</Typography
        >
    {/if}
</div>

<!-- 
    let iref = Object.fromEntries(Object.entries(ref).map(([k, v]) => [v, k]))
    let flatTaxesDef = Object.values(ref)
        .reduce((ac, k) => ac.concat(
            Object.entries(confImp[k])
            .concat(confImp.general.map(x => ['_', ({...x, impuesto: 'general'})])) // General
            .map(([i, conf]) => ({
                id: `${conf.impuesto}_${i}`.toLowerCase(),
                check({title, impuesto}) {
                    let cond = k in iref && iref[k] in taxConf ? taxConf[iref[k]] : '_';
                    let localeHash = `${impuesto}_${cond}`.toLocaleLowerCase()
                    let {label} = conf
                    let pattern = label
                        ?.match(/\$\w+/ig)
                        ?.reduce((r, c) => r.replace(c, '[^\\s]+'), label) || null
                    let rgx = pattern ? new RegExp(pattern, 'i') : null
                    console.log({id: this.id, pattern, rgx, label})
                    return this.id === localeHash && (rgx ? rgx.test(title) : true)
                },
                ...conf
            }))
        ), [])
    console.log({flatTaxesDef})
-->

<style>
    div {
        position: relative;
        width: 100%;
        flex-direction: column;
        height: fit-content;
        display: flex;
        padding: 0 0 0 0;
        justify-content: center;
        align-items: flex-start;
        gap: 25px;
    }
</style>
